export default { sha: '0332d53c8af1cef81252503de311e9cdc3faade6', buildNumber: 'undefined' }
